import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { Spinner } from '../../../components/common';
import WebsiteFormFields from './WebsiteFormFields';

class WebsiteFormPage extends Component {
  render() {
    const { handleSubmit, isLoading, onFormSubmit, website } = this.props;
    return (
      <div>
        <div className='ibox'>
          <div className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Spinner />
            <form
              onSubmit={handleSubmit(onFormSubmit.bind(this, null))}
              className='m-t'
            >
              <WebsiteFormFields website={website} formAction={'Update'} />
              <br />
              <Button
                type='submit'
                loading={isLoading}
                bsStyle='primary'
              >
                Submit
              </Button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'WebsiteForm'
});

const mapStateToProps = (state, ownProps) => {
  const { loader } = state;
  const { website, onFormSubmit } = ownProps;
  const isLoading = loader.includes('WebsiteForm');

  const initialValues = {
    website: {
      name: website.name,
      url: website.url,
      cpa: website.cpa,
      cpc: website.cpc,
      default_slots: website.default_slots,
      sandbox: website.sandbox === true ? 'sandbox' : 'live'
    }
  };

  return { isLoading, website, onFormSubmit, initialValues };
};

export default connect(mapStateToProps)(ResourceForm(WebsiteFormPage));
